/** Long enough for every browser to have started the download: the click
 *  only queues it, and Safari and Firefox cancel a download whose object URL
 *  is revoked in the same tick. */
export const DOWNLOAD_URL_REVOKE_DELAY_MS = 30_000;

/** The only place allowed to touch `document` for file downloads, so
 *  components stay free of direct DOM access. The anchor is attached while
 *  it is clicked (some browsers ignore a detached one) and removed straight
 *  after; the URL is revoked later, in `finally`, so a blocked click can't
 *  leak the blob. */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.hidden = true;
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
    setTimeout(() => URL.revokeObjectURL(url), DOWNLOAD_URL_REVOKE_DELAY_MS);
  }
}
